import { useState } from 'react'
import { useMutation } from 'react-query'
import * as Sentry from '@sentry/react'
import Cookies from 'js-cookie'
import { getCartAmount } from '../api'
import isEmpty from 'lodash/isEmpty'

const useGetCartAmount = () => {
    const [errorMessage, setErrorMessage] = useState('')
    const [errorCode, setErrorCode] = useState('')

    const { mutate, data, isLoading, isSuccess, isError, reset } = useMutation(
        getCartAmount,
        {
            onError: (cartAmountError, context) => {
                const {
                    response: {
                        data: { error, error_code },
                    },
                } = cartAmountError
                const defaultErrorMessage =
                    'Error processing fetching cart amount.'

                setErrorMessage(error ?? defaultErrorMessage)
                if (error_code) {
                    setErrorCode(error_code)
                }
                Sentry.captureException(cartAmountError, {
                    level: Sentry.Severity.Info,
                    user: {
                        id: JSON.stringify(Cookies.get('GCG_CLIENT_USER_ID')),
                    },
                })
            },
        }
    )

    return {
        mutate,
        data,
        isLoading,
        isSuccess,
        isError,
        errorMessage,
        errorCode,
        reset,
    }
}

export default useGetCartAmount
